import React from "react";
// import { image1 } from "../../../assets";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import { dataWisata } from "../../../store/dataWisata";
import { dataBudaya } from "../../../store/dataBudaya";
import { dataKuliner } from "../../../store/dataKuliner";
import Carousel from "better-react-carousel";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from 'react-scroll';

const Card = ({ judul, mini_description, type, image, id, onClick }) => (
    <div className="w-full">
        <Link to={`/${type}/${id}`} onClick={onClick} key={id}>
            <div className="flex justify-center">
                <img src={image} alt="gambar" className="w-60" />
            </div>
            <div className="py-3">
                <h1 className="font-bold text-xl">{judul}</h1>
                <h1 className="text-lg">{mini_description}</h1>
            </div>
        </Link>
    </div>
)

const HeaderTentang = () => {
    const scrollToTop = () => {
        scroll.scrollToTop();
    }

    const image1 = "https://res.cloudinary.com/dkltotiq0/image/upload/v1676291330/IMG20200613161145_il4z2f.jpg";

    return (
        <div className="px-4 lg:px-0" id="tentang-giliiyang">
            <div className="pt-20 mb-12 flex flex-col lg:flex-row">
                <div className="lg:w-3/5 lg:mr-8 my-auto">
                    <div style={{ backgroundImage: `url(${image1})`, backgroundSize: 'cover', backgroundPosition: 'center center' }} className="w-full h-[600px]">
                    </div>
                </div>
                <div className="lg:w-2/5 pt-4 lg:pr-8">
                    <h1 className="text-3xl font-bold py-4">Tentang Gili Iyang</h1>
                    <div className="text-xl leading-relaxed">
                        <p className="text-justify mb-2">Desa Banraas adalah salah satu nama desa yang terletak di pulau Giliyang Kecamatan Dungkek, Kabupaten Sumenep, Jawa Timur. Desa Banraas memiliki enam dusun yaitu Raas barat, Raas timur , bungkok, kalompang, baru, dan assem. Desa banraas memiliki luas wilayah sekitar 4 meter persegi. Dengan jumlah penduduk sekitar 4200an jiwa. Penduduk banraas mayoritas beragama Islam. Sebagian besar penduduk desa Banraas merantau di luar pulau Giliyang. </p>
                        <p className="text-justify mb-2">Aktifitas yang dilakukan sehari- hari oleh warga adalah sebagai nelayan, bercocok tanam sekaligus sebagai peternak. Hal tersebut terlihat dari banyaknya lahan pertanian yang banyak ditananami jagung serta umbi-umbian, kapal nelayan yang berada di pinggir lautan biasanya dipakai oleh nelayan mencari ikan. Dalam beternak, warga desa pada umumnya beternak sapi dan kambing, cara meletakkan pakan ternaknya terbilang unik dan berbeda dengan desa lain yaitu dengan meletakkan dedaunan di atas pohon</p>
                    </div>
                </div>
            </div>
            <div className="flex justify-center">
                <div className="container">
                    <Tabs>
                        <TabList>
                            <Tab><p className="px-12">Wisata</p></Tab>
                            <Tab><p className="px-12">Budaya</p></Tab>
                            <Tab><p className="px-12">Kuliner</p></Tab>
                        </TabList>

                        {/* Wisata */}
                        <TabPanel>
                            <div className="py-8">
                                <Carousel cols={3} rows={1} gap={24} loop autoPlay>
                                    {
                                        dataWisata.map((wisata) => {
                                            return (
                                                <Carousel.Item className="px-12" key={wisata.id}>
                                                    <Card
                                                        id={wisata.id}
                                                        type={wisata.content_type}
                                                        judul={wisata.name}
                                                        mini_description={wisata.mini_description}
                                                        image={wisata.image_path}
                                                        onClick={scrollToTop}
                                                    />
                                                </Carousel.Item>
                                            )
                                        })
                                    }

                                </Carousel>
                            </div>
                        </TabPanel>

                        {/* Budaya */}
                        <TabPanel>
                            <div className="py-8">
                                <Carousel cols={3} rows={1} gap={24} loop autoPlay>
                                    {
                                        dataBudaya.map((budaya) => {
                                            return (
                                                <Carousel.Item className="px-12" key={budaya.id}>
                                                    <Card
                                                        id={budaya.id}
                                                        type={budaya.content_type}
                                                        judul={budaya.name}
                                                        mini_description={budaya.mini_description}
                                                        image={budaya.image_path}
                                                        onClick={scrollToTop}
                                                    />
                                                </Carousel.Item>
                                            )
                                        })
                                    }

                                </Carousel>
                            </div>
                        </TabPanel>

                        {/* Kuliner */}
                        <TabPanel>
                            <div className="py-8">
                                <Carousel cols={3} rows={1} gap={24} loop autoPlay>
                                    {
                                        dataKuliner.map((kuliner) => {
                                            return (
                                                <Carousel.Item className="px-12" key={kuliner.id}>
                                                    <Card
                                                        id={kuliner.id}
                                                        type={kuliner.content_type}
                                                        judul={kuliner.name}
                                                        mini_description={kuliner.mini_description}
                                                        image={kuliner.image_path}
                                                        onClick={scrollToTop}
                                                    />
                                                </Carousel.Item>
                                            )
                                        })
                                    }
                                </Carousel>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        </div>
    )
}

export default HeaderTentang;